import { SagaIterator } from 'redux-saga';
import { PARTNER_DASHBOARD_RESET } from 'src/modules/partner-dashboard/actions/PartnerDashboardActions';
import { logDebug } from 'src/sagas/utils/logging';
import { call, put } from 'typed-redux-saga';

export function* resetPartnerDashboard(): SagaIterator<void> {
  yield* call(logDebug, 'Resetting partner dashboard data...');
  yield* put(PARTNER_DASHBOARD_RESET.trigger());
  yield* call(logDebug, 'Resetting partner dashboard data... done');
}
